import { assign } from "lodash";
import { distinctUntilChanged } from "rxjs/operators";
import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl, FormGroup } from "@angular/forms";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-chapter-main',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './chapter-main.component.html',
    styleUrls: ['./chapter-main.component.scss'],
    standalone: false
})
export class ChapterMainComponent {
  activeIndex = signal(0);
  #node: FlatModels.NodeEntityModels.NodeEntityType | null;
  #page: FlatModels.PageEntityModels.PageEntityType | null;
  titleForm = new FormGroup({
    title: new FormControl('')
  },
  {
    validators: ZodSharedValidator.validate(FlatModels.PageEntityModels.PageSchema.pick({
      title: true
    })),
    updateOn: 'change'
  })
  readonly FlatModels = FlatModels;

  constructor(protected appSharedFacade: FlatFacades.AppSharedFacade,
              protected nodeSharedFacade: FlatFacades.NodeSharedFacade,
              private alertControlFacade: FlatFacades.AlertControlFacade) {
    // Fix select first element in TabView
    this.nodeSharedFacade.currentSelectedNode$.pipe(takeUntilDestroyed(), distinctUntilChanged((a, b) => a?.id === b?.id)).subscribe((node) => {
      if (!node || this.#node?.id === node.id) return;
      this.#node = node;
      this.activeIndex.set(1);
      setTimeout(() => {
        this.activeIndex.set(0);
      });
    });

    this.nodeSharedFacade.currentSelectedPage$.pipe(takeUntilDestroyed()).subscribe((page) => {
      this.#page = structuredClone(page);
      if (this.#page) {
        this.titleForm.reset({ title: this.#page.title });
      }
    })
  }

  onSubmit() {
    // Update Page
    const page = assign(this.#page, {title: this.titleForm.value.title});
    this.nodeSharedFacade.requestUpdatePage(page, 'history.page_update_title').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.titleForm);
      }
    });
  }
}
